import { render, staticRenderFns } from "./SettingsProgramsForm.vue?vue&type=template&id=2d52e7f5"
import script from "./SettingsProgramsForm.vue?vue&type=script&lang=js"
export * from "./SettingsProgramsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports